'use client'
import React, {useContext} from 'react';
import { ProductContext } from '../../lib/productContext';
import InlineFormWrapper from '@/components/inlineFormWrapper';
import { Flex, Tag, TagLabel, Text } from '@chakra-ui/react';
import ProductAsideTypeForm from './productAsideTypeForm';
import { ProductPageContext } from '../lib/productPageContext';
export default function ProductAsideType() {
  const {
    product,
    rights,
    types
  } = useContext(ProductContext);
  const {
    editingTypes,
    setEditingTypes
  } = useContext(ProductPageContext);
  return (
    <Flex
      px={3}
      py={2}
      >
      {((product && (types && types.length > 0)) || editingTypes) && (
        <InlineFormWrapper
          width={"100%"}
          canEdit={rights.can_update}
          toggle={editingTypes}
          onToggle={(toggle) => {
            setEditingTypes(toggle);
          }}
          value={
            <Flex
              gap={1}
              flexWrap={"wrap"}
              >
              {types && types.map((t,i) => (
                <Tag
                  variant="purple"
                  key={i}
                  >
                  <TagLabel>{t.label}</TagLabel>
                </Tag>
              ))}
            </Flex>
          }
        >
          {(close) => (
            <ProductAsideTypeForm
            onSubmitted={() => {
              close();
              setEditingTypes(false);
            }}
            onCancel={() => {
              close();
              setEditingTypes(false);
            }}
            />
          )}
        </InlineFormWrapper>
      )}
    </Flex>
  )
}
